// @flow

import * as React from 'react';

import FirstLoadController from '../../components/FirstLoadController';
import Module from './Inventory';

type Props = {
  active: boolean,
};

export default function(props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Module {...props} />
    </FirstLoadController>
  );
}
